/**
 * Copyright © 2026 Adnuntius AS.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {QuillModule} from 'ngx-quill';
import {PopoverModule} from 'ngx-bootstrap/popover';

import {AppSharedModule} from '../../app-shared.module';
import {AdminRichTextFieldComponent} from './admin-rich-text-field.component';
import {NotesComponent} from './notes.component';
import {ObjectNotesButtonComponent} from './object-notes-button.component';

const NOTES = [
  AdminRichTextFieldComponent,
  NotesComponent,
  ObjectNotesButtonComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    QuillModule,
    PopoverModule
  ],
  declarations: NOTES,
  exports: NOTES
})
export class NotesModule {
}
